<template>
  <v-container class="py-0">
    <v-row justify="center">
      <v-col :cols="12" :sm="9" :md="10" :lg="11" :xl="11" class="py-0 px-0">
        <helper-offset class="px-3 pb-4">
          <v-card scrollable class="card_style">
            <v-card flat>
              <v-card-title class="d-flex headline pl-5 pt-6 pb-0">
                <span
                  class="mr-1"
                  style="font-family:explorerTitleFont;font-size:20px;font-weight:600;"
                  >Token Info</span
                >
                <span
                  v-if="this.$config.net && this.$config.net === 'testnet'"
                  style="width:51px;font-size:14px;font-weight:400;"
                  >- VTEST</span
                >
              </v-card-title>
              <v-card
                class="d-flex"
                v-if="breakpoint === 'lg' || breakpoint === 'xl'"
                flat
              >
                <list-view
                  :data="tokenInfo"
                  :attributes="tokenAttrLeft"
                  :limit="tokenAttrLeft.length"
                  :links="tokenLinks"
                  class="pb-0"
                  dimension="double"
                />
                <list-view
                  :data="tokenInfo"
                  dimension="double"
                  :limit="tokenAttrRight.length"
                  :attributes="tokenAttrRight"
                  :links="tokenLinks"
                  class="pb-0"
                />
              </v-card>
              <list-view
                v-else
                :data="tokenInfo"
                :attributes="tokenAttrLeft.concat(tokenAttrRight)"
                :links="tokenLinks"
                class="pb-0"
              />
            </v-card>
          </v-card>
        </helper-offset>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col :cols="12" :sm="10" :md="10" :lg="11" :xl="11" class="py-0 px-0">
        <v-container>
          <v-card flat>
            <v-row>
              <v-col cols="auto" class="pt-0 pb-5">
                <span
                  style="font-family:explorerTitleFont;font-size:20px;font-weight:600;"
                  >Latest Transactions</span
                >
              </v-col>
              <v-spacer></v-spacer>
              <!-- <v-col cols="auto" class="py-0">
                <v-menu offset-y min-width="100">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      text
                      height="25"
                      style="min-width:0px !important; padding:0px !important;"
                      v-on="on"
                    >
                      <span class="original-text-button text-capitalize">
                        {{
                        type
                        }}
                      </span>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="color:primary">
                    <v-list-item
                      v-for="(item, index) in txTypes"
                      :key="index"
                      @click="searchByType(item)"
                    >
                      <v-list-item-title>
                        <span :class="menuItemFontColor(item)">{{ item }}</span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>-->
            </v-row>
          </v-card>
          <v-card flat>
            <expand-table
              :prop-limit="limit"
              :apiUrl="apiUrl"
              :params="txParams"
              :links="links"
              :attributes="attributes"
              :order="order"
              :subtile="subtile"
              :hasBoundry="true"
              ref="txTable"
              class="pt-0"
            />
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListView from "../material/ListView.vue";
import ExpandTable from "../material/ExpandTable.vue";
import helperOffset from "@/helper/Offset.vue";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    ListView,
    ExpandTable,
    helperOffset
  },
  data() {
    return {
      type: "all",
      txTypes: ["all", "init", "send", "supercede", "issue", "destroy"],
      attributes: [
        { text: "ID", value: "transactionId" },
        { text: "Amount", value: "amountStr" }
      ],
      subtile: {
        transactionId: {
          type: "prop",
          property: "timestamp",
          propType: "timestamp",
          text: "ID"
        },
        timestamp: { type: "time_ago", text: "Timestamp" },
        amountStr: {
          type: "transform_unity",
          text: "Amount",
          mobileHidden: true,
          align: "right"
        },
        signer: { type: "address", text: "Sender" },
        // functionIndexType: { type: "text", text: "Type" },
        recipient: { type: "address", text: "Recipient" },
        status: { type: "status", text: "Status" },
        height: {
          type: "thousands",
          text: "Block Height",
          computerHidden: true
        }
      },
      order: ["signer", "recipient", "status", "height"],
      limit: 10,
      apiUrl: `${this.$config.apiEndPoint}/token/transactions`,
      vExplorerApis: {
        mainnet: "https://explorer.v.systems/transactions/",
        testnet: "https://testexplorer.v.systems/transactions/"
      },
      tokenLinks: {
        issuer: "/address/:address",
        maker: "/address/:address",
        transactionId: "https://explorer.v.systems/transactions/"
      },
      links: {
        transactionId: "/transaction/:transactionId",
        signer: "/address/:address",
        recipient: "/address/:address"
      },
      tokenAttrLeft: [
        { text: "Transactions", value: "transactionCount" },
        { text: "Max Supply", value: "maxSupplyStr", type: "transform_unity" },
        {
          text: "Current Supply",
          value: "currentSupplyStr",
          type: "transform_unity"
        },
        { text: "Block Height", value: "startHeight", type: "thousands" },
        { text: "Last Issue Time", value: "lastIssuedTime", type: "timestamp" },
        { text: "Unity", value: "unity", type: "thousands" },
        { text: "Description", value: "description" }
      ],
      tokenAttrRight: [
        { text: "Issuer", value: "issuer", type: "address" },
        { text: "Token ID", value: "tokenId" },
        { text: "Transaction ID", value: "transactionId" },
        { text: "Contract ID", value: "contractId" },
        { text: "Maker", value: "maker", type: "address" },
        { text: "Register Time", value: "timestamp", type: "timestamp" },
        { text: "Support Split", value: "canSplit" }
      ],
      txParams: { tokenId: this.$config.tokenId },
      txCountApi: `${this.$config.apiEndPoint}/token/${this.$config.tokenId}/transactionCount`,
      breakpoint: this.$vuetify.breakpoint.name
    };
  },
  computed: {
    ...mapState(["tokenId", "tokenInfo", "reloadPage"])
  },
  async created() {
    this.tokenLinks.transactionId =
      this.$config.net && this.vExplorerApis[this.$config.net]
        ? this.vExplorerApis[this.$config.net]
        : this.vExplorerApis["mainnet"];
    try {
      const res = await this.$http.get(this.txCountApi);
      if (res && res.data && res.data.result) {
        this.tokenInfo.transactionCount = res.data.result;
        this.updateTokenInfo(this.tokenInfo);
      }
    } catch {
      // catch error
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.breakpoint = this.$vuetify.breakpoint.name;
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.breakpoint = this.$vuetify.breakpoint.name;
    });
  },
  methods: {
    ...mapMutations(["updateReloadPage", "updateTokenInfo"]),
    menuItemFontColor(item) {
      return this.type === item
        ? "primary--text text-capitalize"
        : "text-capitalize";
    },
    searchByType(type) {
      this.type = type;
      this.$refs.txTable.searchByType(type);
    },
    isNumeric(n) {
      return typeof n != "boolean" && !isNaN(n);
    }
  }
};
</script>
<style>
.original-text-button {
  text-transform: none;
}
.card_style {
  box-shadow: 0px 2px 20px 0px rgba(68, 68, 68, 0.08);
  border-radius: 0.8rem;
}
@font-face {
  /* font-properties */
  font-family: explorerTitleFont;
  src: url("../../assets/font/SF-Pro-Display-Semibold.otf");
}
</style>
